import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { StaticQuery, graphql, navigate, withPrefix } from 'gatsby';
import { getUserLangKey } from 'ptz-i18n';

import SEO from '../SEO';

// * GetLangPreference is true when a user hits a route like /parents
// * GetLangPreference is false when a user hits a route like /in-en/parents

function Redirect({
  data,
  location,
  getLangPreference,
  origin,
  defaultLangKey = 'en-ca',
}) {
  const determineRedirect = () => {
    if (typeof window !== 'undefined') {
      // * Array of all langs for the website
      const langs = data.prodigy.localeMappings.map(
        (langData) => langData.locale
      );
      // * Check if it should redirect to defaultlang, or get a user's pref lang
      const langKey = getLangPreference
        ? getUserLangKey(langs, defaultLangKey)
        : defaultLangKey;
      // * Need to match returned lang with correct path
      const prefix = data.prodigy.localeMappings.find(
        (localeData) => localeData.locale === langKey
      );

      // remove any extra slashes found in the location at the start or end of string
      /*eslint-disable */
      if (location[0] === '/') {
        location = location.substring(1);
      }

      if (location[location.length - 1] === '/') {
        location = location.slice(0, -1);
      }

      // * The Url to be navigated to
      const url = getLangPreference
        ? withPrefix(
            location === '' || location === null || location === undefined
              ? `/${prefix.path}/`
              : `/${prefix.path}/${location}/`
          )
        : withPrefix(`/${prefix.path}`);
      return url;
      /* eslint-enable */
    }
    return undefined;
  };

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const url = determineRedirect();
      navigate(url, { replace: true });
    }
  }, []);

  /* Provide helmet with redirect arguments for accurate canonical tag setting, don't perform double render */
  return <SEO location={origin} redirect={determineRedirect()} />;
}

Redirect.propTypes = {
  data: PropTypes.shape().isRequired,
  location: PropTypes.string.isRequired,
  origin: PropTypes.string.isRequired,
  getLangPreference: PropTypes.bool.isRequired,
  defaultLangKey: PropTypes.string.isRequired,
};

// * StaticQuery Component that retrieves and passes in all the articles
const withStaticQueryRedirect = ({
  location,
  getLangPreference,
  origin,
  defaultLangKey,
}) => (
  <StaticQuery
    query={graphql`
      query LocaleMappingQuery {
        prodigy {
          localeMappings {
            path
            locale
          }
        }
      }
    `}
    render={(data) => (
      <Redirect
        data={data}
        origin={origin}
        location={location}
        getLangPreference={getLangPreference}
        defaultLangKey={defaultLangKey}
      />
    )}
  />
);

withStaticQueryRedirect.propTypes = {
  location: PropTypes.string.isRequired,
  getLangPreference: PropTypes.bool,
  origin: PropTypes.string.isRequired,
  defaultLangKey: PropTypes.string.isRequired,
};

withStaticQueryRedirect.defaultProps = {
  getLangPreference: true,
};

export default withStaticQueryRedirect;
